import Message from 'messaging/models/Message'
import { MessageType } from 'messaging/models/MessageType'
import { computed, makeObservable } from 'mobx'

export interface MessageContentViewModel {
  message: Message
  activate?(): Promise<void>
  deactivate?(): Promise<void>
}

export default class MessageViewModel {
  constructor(
    public message: Message,
    public content: MessageContentViewModel,
  ) {
    makeObservable(this)
  }

  /**
   * Message type.
   */
  @computed
  get messageType() {
    return this.message.messageType
  }

  /**
   * Message content type.
   */
  @computed
  get contentType() {
    return this.message.content.type
  }

  async activate() {
    await this.content.activate?.()
  }

  async deactivate() {
    await this.content.deactivate?.()
  }

  /**
   * Checks if the message is editable by the message type.
   */
  @computed
  get isEditable() {
    return (
      this.messageType === MessageType.AdminMessage ||
      this.messageType === MessageType.Message
    )
  }
}
